import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

const Contact = () => {

   return (
      <ContactStyles id="contact">
         <div className="title-box">
            <h2>お問い合わせ</h2>
            <div className="deco"></div>
         </div>
         <div className="texts">
            <p className="come">個別面談・体験授業実施中</p>
            <p className="here">ご質問・ご相談はこちらから</p>
            <p className="tel">042-507-1948</p>
            <div className="contact-time">
               <p>受付時間</p>
               <p>平日：15:00 ~ 21:00</p>
               <p>土曜：13:00 ~ 20:00</p>
               <p>（日曜定休）</p>
            </div>
         </div>
      </ContactStyles>
   )
}

const ContactStyles = styled.section`
   width: 100%;
   margin-top: 1px;

   .texts {
      padding: 78px 0;
      text-align: center;
      color: #FF3D01;
      .come {
         font-size: 3rem;
         letter-spacing: 0.45rem;
         ${media.lessThan("960px")`
            font-size: 2.5rem;
         `}
         ${media.lessThan("600px")`
            font-size: 2.1rem;
         `}
      }
      .here {
         font-size: 2.4rem;
         margin-top: 10px;
         letter-spacing: 0.36rem;
         ${media.lessThan("960px")`
            font-size: 2rem;
         `}
         ${media.lessThan("600px")`
            font-size: 1.6rem;
         `}
      }
      .tel {
         font-size: 5.4rem;
         margin-top: 30px;
         letter-spacing: 1.8rem;
         font-weight: bold;
         ${media.lessThan("960px")`
            font-size: 4rem;
         `}
         ${media.lessThan("600px")`
            font-size: 3rem;
            letter-spacing: 1rem;
         `}
      }
      .contact-time {
         margin-top: 30px;
         p {
            font-size: 2.8rem;
            margin-top: 10px;
            letter-spacing: 0.43rem;
            ${media.lessThan("960px")`
               font-size: 2.3rem;
            `}          
            ${media.lessThan("600px")`
               font-size: 1.8rem;
            `}
            &:first-child {
               margin-top: 0;
            }

         }
      }
   }
`

export default Contact